import { Link } from "react-router-dom";

const stats = [
  { value: "3+", label: "覆盖体育项目", icon: "ri-apps-2-line" },
  { value: "24/7", label: "全天滚动更新", icon: "ri-refresh-line" },
  { value: "高清", label: "多路画质切换", icon: "ri-hd-line" },
];

const features = [
  {
    icon: "ri-flashlight-line",
    title: "实时同步",
    desc: "比分、进度、赛事状态实时滚动，第一时间掌握赛场动态。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "多赛事并行",
    desc: "同一页面即可浏览多场正在进行与即将开始的比赛。",
  },
  {
    icon: "ri-search-eye-line",
    title: "快速检索",
    desc: "支持按联赛、球队、项目快速筛选与搜索，找比赛不再费劲。",
  },
];

export default function BrandIntro() {
  return (
    <section className="border-t border-background-200 bg-background-100/60">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-400">
            <span className="h-1 w-1 rounded-full bg-primary-500" />
            About jrs直播
          </span>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            为体育迷打造的赛事直播门户
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            jrs直播专注于体育赛事直播内容聚合，覆盖篮球、足球、电竞等热门项目。
            我们关注赛事实时动态，力求让每一位观众都能在同一个平台上，轻松找到并观看自己关心的比赛，
            无论是凌晨的欧洲联赛，还是深夜的电竞决赛。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line" />
              了解更多
            </Link>
            <Link
              to="/schedule"
              className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500/50 hover:text-primary-400 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-schedule-line" />
              查看完整赛程
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                <i className={`${f.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {f.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                {f.desc}
              </p>
            </div>
          ))}
          <div className="rounded-lg border border-primary-500/30 bg-primary-500/10 p-5 sm:col-span-1">
            <div className="grid grid-cols-3 gap-2 sm:block sm:space-y-3">
              {stats.map((s) => (
                <div key={s.label} className="flex items-center gap-2.5">
                  <i className={`${s.icon} text-lg text-primary-400`} />
                  <div>
                    <div className="font-heading text-base font-bold text-foreground-950">
                      {s.value}
                    </div>
                    <div className="text-[11px] text-foreground-500">
                      {s.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}